import { Location } from "history";
import { matchPath } from "react-router-dom";
import { MODAL_ROUTES } from "routing/routes";

import { linkToRegionModal } from "common/links";

import {
  linkToDashboard,
  linkToDashboardFeedback,
  linkToDashboardInviteParentsModal,
  linkToSetDailyXPGoal,
  linkToUpdateDailyXPGoal
} from "features/dashboard/links";
import { linkToStudentClassPagePrefix } from "features/dashboard/pages/class-page/links";
import { linkToStudentClasses } from "features/dashboard/pages/classes/links";
import { linkToMorePage } from "features/dashboard/pages/more-page/links";
import { linkToSettings } from "features/dashboard/pages/settings-page/links";

export function locationIncludesMoreRoute(location: Location) {
  return (
    location.pathname.includes(linkToMorePage()) ||
    location.pathname.includes(linkToSettings()) ||
    location.pathname.includes(linkToDashboardFeedback()) ||
    location.pathname.includes(linkToDashboardInviteParentsModal()) ||
    location.pathname.includes(linkToRegionModal())
  );
}

export function locationIncludesAssignmentsRoute({
  location
}: {
  location: Location;
}) {
  return (
    location.pathname.includes(linkToStudentClasses()) ||
    !!matchPath(location.pathname, {
      path: MODAL_ROUTES.UNLOCK_DARK_MODE.buildPath({})
    }) ||
    location.pathname.includes(linkToStudentClassPagePrefix())
  );
}

export function locationIncludesDashboardRoute({
  location
}: {
  location: Location;
}) {
  return (
    !!matchPath(location.pathname, {
      path: linkToDashboard(),
      exact: true
    }) ||
    location.pathname.includes(linkToSetDailyXPGoal()) ||
    location.pathname.includes(linkToUpdateDailyXPGoal())
  );
}
